import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectCuttingDatalist, selectCuttingMemoWise } from '../../Selectors/Master/ItemSelectors';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import { fetchCuttingList, fetchCuttingMemoWise } from '../../../Store/PHPSlice/Cutting/cuttingApi';
import FirmHeaderImg from '../../FieldsComponents/FirmHeaderImg';

const CuttingInfoView = () => {
    const [formData, setFormData] = useState({
        dt: '',
        empNm: '',
        empType: '',
        instruction: '',
        itemNm: '',
        memoNo: '',
        totQty: '',
        mcloth: '',
        mclothNm: '',
        gMtr: '',
        reqMtr: '',
        m1cloth: '',
        m1clothNm: '',
        m1gMtr: '',
        m1req: '',
        m2cloth: '',
        m2clothNm: '',
        m2gMtr: '',
        m2req: '',
        m3cloth: '',
        m3clothNm: '',
        m3gMtr: '',
        m3req: '',
        soId: '',
        sono: '',
        partyId: '',
        partyNm: '',
        firmId: ''
    });
    const { Id } = useParams();
    const dispatch = useDispatch();
    // const cutInfolist = useSelector(selectCuttingDatalist);
    const cutInfolist = useSelector(selectCuttingMemoWise);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef(); // Ref for the component to be printed
    useEffect(() => {
        // dispatch(fetchCuttingList(Id));
        dispatch(fetchCuttingMemoWise(Id));
    }, [Id, dispatch]);


    useEffect(() => {
        if (cutInfolist.cuttingCloths && cutInfolist.cuttingCloths.length > 0) {
            const item = cutInfolist.cuttingCloths[0];
            setFormData(prev => ({
                ...prev,
                mcloth: item.mcloth || '',
                mclothNm: item.mclothNm || '',
                gMtr: item.mgmtr || '',
                reqMtr: item.mreq || '',
                m1cloth: item.m1cloth || '',
                m1clothNm: item.m1clothNm || '',
                m1gMtr: item.m1gmtr || '',
                m1req: item.m1req || '',
                m2cloth: item.m2cloth || '',
                m2clothNm: item.m2clothNm || '',
                m2gMtr: item.m2gmtr || '',
                m2req: item.m2req || '',
                m3cloth: item.m3cloth || '',
                m3clothNm: item.m3clothNm || '',
                m3gMtr: item.m3gmtr || '',
                m3req: item.m3req || '',
                instruction: item.instruction || '',
            }));
        }
    }, [cutInfolist]);
    useEffect(() => {
        if (cutInfolist.data && cutInfolist.data.length > 0) {
            const item = cutInfolist.data[0];
            setFormData(prev => ({
                ...prev,
                dt: item.dt || '',
                empNm: item.empNm || '',
                empType: item.empType || '',
                itemNm: item.itemNm || '',
                memoNo: item.memoNo || '',
                totQty: item.totQty || '',
                soId: item.soId || '',
                sono: item.sono || '',
                partyId: item.partyId || '',
                partyNm: item.partyNm || '',
                firmId: item?.firm || ''
            }));
        }
    }, [cutInfolist]);



    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };
    var itemData = cutInfolist.cuttingInfo.length > 0 ? {
        size: cutInfolist.cuttingInfo.map(val => val.size),
        mavg: cutInfolist.cuttingInfo.map(val => parseFloat(val.mavg)),
        m1avg: cutInfolist.cuttingInfo.map(val => parseFloat(val.m1avg)),
        m2avg: cutInfolist.cuttingInfo.map(val => parseFloat(val.m2avg)),
        m3avg: cutInfolist.cuttingInfo.map(val => parseFloat(val.m3avg)),
        qty: cutInfolist.cuttingInfo.map(val => parseFloat(val.qty)),
        soqty: cutInfolist.cuttingInfo.map(val => parseFloat(val.soqty))
    } : [];

    // console.log(cutInfolist)
    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '2vh', margin: '0' }}>
                    <div style={{ margin: '1%', width: '100%' }} ref={componentRef}>
                        {formData.firmId !== '' && <FirmHeaderImg firmId={formData.firmId}/>}

                        {formData.empType === '1' ? <h3 className='centered-heading'>Cutting Info</h3> : <h3 className='centered-heading'>Contractor Info</h3>}
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: '200px' }}>Date</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.dt}</td>

                                    <td style={{ width: '200px' }}>Memo No.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.memoNo}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Master</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.empNm}</td>
                                    {/* <td style={{ width: '200px' }}>Sale Order No.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.sono !== '0' ? formData.sono : '-'}</td> */}
                                </tr>


                            </tbody>
                        </table>

                        {cutInfolist?.data?.map((item, index) => (
                            <div key={index}>
                                <div className="dashed-line"></div>
                                <table style={{ margin: '1% 5%', fontSize: '14px' }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ width: '200px' }}>Item Name</td>
                                            <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{item.itemNm}</td>

                                            <td style={{ width: '200px' }}>SO No.</td>
                                            <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{item.sono}</td>
                                        </tr>

                                        <tr>
                                            <td style={{ width: '200px' }}>Total Qty.</td>
                                            <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{item.totQty}</td>
                                            {/* <td style={{ width: '200px' }}>Sale Order No.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.sono !== '0' ? formData.sono : '-'}</td> */}
                                        </tr>


                                    </tbody>


                                </table>

                                {item?.cloths[0] &&
                                    <table style={{ margin: '1% 5%', fontSize: '14px' }}>
                                        <tbody>
                                            <tr>
                                                <td style={{ width: '100px' }}>Main Cloth</td>
                                                <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{item?.cloths[0].mclothNm}</td>
                                                <td style={{ width: '100px' }}>Given Mtr.</td>
                                                <td style={{ width: '10vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{item?.cloths[0].mgmtr}</td>
                                                <td style={{ width: '100px' }}>Required Mtr.</td>
                                                <td style={{ width: '10vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{item?.cloths[0].mreq}</td>
                                            </tr>

                                            {item?.cloths[0].m1cloth !== '0' &&
                                                <tr>
                                                    <td style={{ width: '100px' }}>Matching-1</td>
                                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{item?.cloths[0].m1clothNm}</td>
                                                    <td style={{ width: '100px' }}>Given Mtr.</td>
                                                    <td style={{ width: '10vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{item?.cloths[0].m1gmtr}</td>
                                                    <td style={{ width: '100px' }}>Required Mtr.</td>
                                                    <td style={{ width: '10vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{item?.cloths[0].m1req}</td>
                                                </tr>
                                            }

                                            {item?.cloths[0].m2cloth !== '0' &&
                                                <tr>
                                                    <td style={{ width: '100px' }}>Matching-2</td>
                                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{item?.cloths[0].m2clothNm}</td>
                                                    <td style={{ width: '100px' }}>Given Mtr.</td>
                                                    <td style={{ width: '10vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{item?.cloths[0].m2gmtr}</td>
                                                    <td style={{ width: '100px' }}>Required Mtr.</td>
                                                    <td style={{ width: '10vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{item?.cloths[0].m2req}</td>
                                                </tr>
                                            }

                                            {item?.cloths[0].m3cloth !== '0' &&
                                                <tr>
                                                    <td style={{ width: '100px' }}>Matching-3</td>
                                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{item?.cloths[0].m3clothNm}</td>
                                                    <td style={{ width: '100px' }}>Given Mtr.</td>
                                                    <td style={{ width: '10vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{item?.cloths[0].m3gmtr}</td>
                                                    <td style={{ width: '100px' }}>Required Mtr.</td>
                                                    <td style={{ width: '10vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{item?.cloths[0].m3req}</td>
                                                </tr>
                                            }
                                        </tbody>

                                    </table>
                                }

                                {item?.cutInfo?.length > 0 &&


                                    <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                        <Table>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Size</TableCell>
                                                    {item?.cutInfo?.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val.size}</TableCell>
                                                    ))}
                                                </TableRow>

                                                {item?.cloths[0].mcloth !== '0' &&
                                                    <TableRow>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Main Avg.</TableCell>
                                                        {item?.cutInfo?.map((val, index) => (
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val.mavg}</TableCell>
                                                        ))}
                                                    </TableRow>
                                                }

                                                {item?.cloths[0].m1cloth !== '0' &&
                                                    <TableRow>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Matching-1 Avg.</TableCell>
                                                        {item?.cutInfo?.map((val, index) => (
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val.m1avg}</TableCell>
                                                        ))}
                                                    </TableRow>
                                                }

                                                {item?.cloths[0].m2cloth !== '0' &&
                                                    <TableRow>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Matching-2 Avg.</TableCell>
                                                        {item?.cutInfo?.map((val, index) => (
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val.m2avg}</TableCell>
                                                        ))}
                                                    </TableRow>
                                                }

                                                {item?.cloths[0].m3cloth !== '0' &&
                                                    <TableRow>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Matching-3 Avg.</TableCell>
                                                        {item?.cutInfo?.map((val, index) => (
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val.m3avg}</TableCell>
                                                        ))}
                                                    </TableRow>
                                                }
                                                {formData.soId !== '0' &&
                                                    <TableRow>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>SO Qty.</TableCell>
                                                        {itemData?.soqty ? itemData?.soqty?.map((val, index) => (
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val}</TableCell>
                                                        )) : null}
                                                    </TableRow>
                                                }

                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Qty.</TableCell>
                                                    {item?.cutInfo?.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val.qty}</TableCell>
                                                    ))}
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }
                            </div>
                        ))
                        }


                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: '200px' }}>Cutting Instructions</td>
                                    <td style={{ width: '800px', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.instruction}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>
                </Paper>
            </Grid >
        </>
    );
};

export default CuttingInfoView;
